<template>
    <div class="">
        <div class="tw-mt-4 tw-flex" v-for="(salary, index) in salaries" v-if="salaries.length > 0">
            <input type="hidden" :name="'salaries[' + index + '][id]'" :value="salary.id">

            <div>
                <bordered-input>
                    <template #label>
                        <label :for="'salaries_amount_' + index">
                            Gehalt
                        </label>
                    </template>
                    <template #input>
                        <input :id="'salaries_amount_' + index" :name="'salaries[' + index + '][amount]'" type="text" placeholder="Gehalt" v-model="salary.amount">
                    </template>
                </bordered-input>
            </div>

            <div class="tw-ml-2">
                <bordered-input>
                    <template #label>
                        <label :for="'salaries_valid_from_' + index">
                            Gültig ab
                        </label>
                    </template>
                    <template #input>
                        <input :id="'salaries_valid_from_' + index" :name="'salaries[' + index + '][valid_from]'" type="date" placeholder="Gültig ab" v-model="salary.valid_from">
                    </template>
                </bordered-input>
            </div>

            <button class="cu-btn-default tw-ml-2" type="button" @click="addSalary">
                <i class="fa fa-plus"></i>
            </button>

            <button class="cu-btn-default tw-ml-2" type="button" @click="removeSalary(index)">
                <i class="fa fa-trash-o"></i>
            </button>
        </div>
        <div class="tw-mt-4" v-if="salaries.length === 0">
            <button type="button" class="cu-btn-default" @click="addSalary">
                <i class="fa fa-plus"></i>
                Gehalt eintragen
            </button>
        </div>
    </div>
</template>

<script>
    import BorderedInput from "./BorderedInput";
    import moment from 'moment';

    export default {
        components: {
            BorderedInput,
        },

        props: {
            initialSalaries: {
                required: false,
                default: null,
                type: Array,
            }
        },

        data() {
            return {
                salaries: [],
            }
        },

        methods: {
            addSalary() {
                this.salaries.push({
                    id: null,
                    valid_from: '',
                    amount: '',
                });
            },

            removeSalary(index) {
                this.salaries.splice(index, 1);
            }
        },

        mounted() {
            if (this.initialSalaries.length > 0) {
                this.initialSalaries.forEach(item => {
                    this.salaries.push({
                        id: item.id,
                        valid_from: moment(item.valid_from).format('YYYY-MM-DD'),
                        amount: item.amount,
                    });
                })
            }
        }
    }
</script>